import { DEFAULT_TIMEZONE } from '../features/shared/utils/Formatters';
import moment from 'moment-timezone';

const PARSED_DATE_FORMAT = 'YYYY-MM-DD';
const PARSED_TIME_FORMAT = 'HH:mm:ss';

export default function CutoffSelector({
  cutoffTime = '15:00:00',
  drawdownTimestamp = moment().tz(DEFAULT_TIMEZONE).toISOString(),
  postCutoffDate = null,
  preCutoffDate = null,
} = {}) {
  if (!preCutoffDate || !postCutoffDate) { return null }
  const cutoff = moment(cutoffTime, PARSED_TIME_FORMAT, DEFAULT_TIMEZONE);
  const drawdown = moment(drawdownTimestamp).tz(DEFAULT_TIMEZONE);
  if (drawdown.hour() < cutoff.hour()) { return moment(preCutoffDate).format(PARSED_DATE_FORMAT); }
  if (drawdown.hour() >= cutoff.hour()) { return moment(postCutoffDate).format(PARSED_DATE_FORMAT); }
}


// WEBPACK FOOTER //
// ./src/utils/CutoffSelector.js